// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from MenuGroup.module.scss  */
.MenuGroup-module-Root_3C4 {
  border-bottom: 1px solid #e2e2e2; }
  .MenuGroup-module-Root_3C4:last-child {
    border-bottom: 0; }

.MenuGroup-module-Heading_17l {
  padding-top: 8px;
  padding-left: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  user-select: none;
  text-transform: uppercase;
  color: #585858; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Menu/MenuGroup/MenuGroup.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gCAAgC,EAAE;EAClC;IACE,gBAAgB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc,EAAE","sourcesContent":["/*  imported from MenuGroup.module.scss  */\n.MenuGroup-module-Root_3C4 {\n  border-bottom: 1px solid #e2e2e2; }\n  .MenuGroup-module-Root_3C4:last-child {\n    border-bottom: 0; }\n\n.MenuGroup-module-Heading_17l {\n  padding-top: 8px;\n  padding-left: 12px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  user-select: none;\n  text-transform: uppercase;\n  color: #585858; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
